import React from 'react'
import './mobileMenu.css'
import { userPhotoID } from '../../../constants/images/sizesAndQuality'
import {
  CLOUDINARY_API_KEY,
  CLOUDINARY_NAME,
} from '../../../constants/images/cloudinary'
import * as Cookies from 'js-cookie'
import LoginForm from '../../auth/login/loginForm'
import cloudinary from 'cloudinary-core'
import { isConversationFeatureEnabled } from 'components/utils/featureFlag'
import TwistedAccordion from 'components/elements/accordion'
import { popularBrands } from 'constants/brands'
import { popularLocations } from 'constants/locations'
import LanguageTranslator from '../header/languageTranslator'

const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,

  //upload_preset : CLOUDINARY_VEHICLE_PRESET,
  api_key: CLOUDINARY_API_KEY,
})

let classnames = require('classnames')

class MobileMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false,
    }
  }

  toggleMobileMenu = () => {
    this.setState((prevState) => ({
      menuOpen: !prevState.menuOpen,
    }))
  }

  triggerSignup = (e) => {
    e.preventDefault()
    this.setState({
      menuOpen: false,
    })

    this.props.loginModalFunction('signup', this.props.authObject.openSignUp)
  }

  handleLogin = () => {
    this.setState({
      menuOpen: false,
    })
  }

  render() {
    const {
      isAuth,
      authObject: {
        state: { userFullName, userAvatarID, unreadMessagesCount },
      },
    } = this.props

    let mobileMenuWrapperClass = classnames(
      'mobile-menu-wrapper',
      this.props.className,
      {
        'mobile-menu-wrapper-open': this.state.menuOpen,
      }
    )

    let mobileMenuClass = classnames('mobile-menu', this.props.className, {
      'mobile-menu-open': this.state.menuOpen,
    })

    return (
      <div className={mobileMenuWrapperClass}>
        <div className="mobile-trigger-wrap">
          {!isAuth && (
            <button
              className="mobile-button"
              onClick={() => this.toggleMobileMenu()}
            >
              <i className="fal fa-bars"></i>
            </button>
          )}
          {isAuth && (
            <button className="logged-in-avatar-button">
              <img
                height="60px"
                width="60px"
                src={cl.url(userPhotoID(userAvatarID), {
                  gravity: 'center',
                  height: 60,
                  width: 60,
                  crop: 'fill',
                  format: 'jpg',
                  quality: 80,
                })}
                className="logged-in-avatar"
                onClick={() => this.toggleMobileMenu()}
                alt={userFullName}
              />
              {unreadMessagesCount > 0 && isConversationFeatureEnabled() && (
                <span className="tag is-danger is-rounded badge-mobile">
                  {unreadMessagesCount}
                </span>
              )}
            </button>
          )}
          <LanguageTranslator isMobileView={true}/>
        </div>
        <div
          className="mobile-menu-overlay"
          onClick={() => this.toggleMobileMenu()}
        ></div>

        {this.state.menuOpen && (
          <div className={mobileMenuClass}>
            <div className="is-fullwidth is-block is-relative">
              <button
                className="delete is-extra-large close-menu"
                onClick={(e) => {
                  e.preventDefault()
                  this.toggleMobileMenu()
                }}
              ></button>
            </div>
            <div className="mobile-menu-inner">
              {isAuth && (
                //console.log(userAvatarID),
                <div className="mobile-menu-logged-in-wrap">
                  <img
                    height="100px"
                    width="100px"
                    src={cl.url(userPhotoID(userAvatarID), {
                      gravity: 'center',
                      height: 100,
                      width: 100,
                      crop: 'fill',
                      format: 'jpg',
                      quality: 80,
                    })}
                    className="logged-in-avatar"
                    alt={userFullName}
                  />

                  <div className="user-name">{userFullName}</div>
                  {/*<div className="account-credit"><strong>$400</strong> Account Credit</div>*/}
                  <nav className="mobile-menu-items">
                    <a href="/list-your-motorcycle/calculator">
                      <i className="far fa-dollar-sign"></i> Calculate Earnings
                    </a>
                    <a
                      href="https://merch.twistedroad.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i class="fas fa-tshirt"></i> Merch
                    </a>
                    <a
                      href="https://mailchi.mp/twistedroad/holiday-gift-card-2025"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fas fa-gift"></i> Gift Cards
                    </a>
                    <a href="/account/edit-profile">
                      <i className="fal fa-cog"></i> Account Settings
                    </a>

                    <a href="/dashboard/mytrips">
                      <i className="fal fa-road"></i> My Trips
                    </a>
                    <a href="/dashboard/reservations">
                      <i className="fal fa-money-check-alt"></i> Reservation
                      Requests
                    </a>
                    <a href="/dashboard/garage">
                      <i className="fas fa-th-list"></i> My Listings
                    </a>
                    <a href="/dashboard/favorites">
                      <i className="fal fa-motorcycle"></i> My Saved Motorcycles
                    </a>
                    {isConversationFeatureEnabled() && (
                      <a href="/conversations">
                        <i className="fal fa-comments"></i> My Messages
                        {unreadMessagesCount > 0 &&
                          isConversationFeatureEnabled() && (
                            <div className="tag is-danger is-rounded in-menu-unread-count">
                              {unreadMessagesCount || 0}
                            </div>
                          )}
                      </a>
                    )}
                    <div className="mobile-menu-logged-out-wrap mb-2">
                      <a
                        href="/list-your-motorcycle"
                        className="button is-fullwidth is-primary is-outlined"
                      >
                        List A Bike
                      </a>
                    </div>

                    <a href={'/users/' + Cookies.get('userID')}>
                      <i className="fal fa-user"></i> Profile
                    </a>
                    <button
                      onClick={() => {
                        this.props.logoutFunction(this.props.authObject.logOut)
                        this.setState({ menuOpen: false })
                      }}
                      className="button-as-mobile-menu-link"
                    >
                      <i className="fal fa-sign-out"></i>Log Out
                    </button>
                  </nav>
                </div>
              )}

              {!isAuth && (
                <div className="mobile-menu-logged-out-wrap">
                  <LoginForm
                    showBottomLinks={false}
                    container="page"
                    onSuccess={this.handleLogin}
                    parentDescription="Mobile Menu"
                    hideShadow={true}
                  />

                  <div className="divider has-text-white">OR</div>

                  <a
                    href="/list-your-motorcycle"
                    className="button is-medium is-primary is-fullwidth is-outlined"
                    onClick={(e) => this.triggerSignup(e)}
                  >
                    Sign Up
                  </a>
                </div>
              )}
              <nav className="mobile-menu-items">
                <span className="has-text-weight-bold">Learn More</span>
                <div className='popular-locations'>
                  <TwistedAccordion
                    title="Popular Locations"
                    items={popularLocations}
                  />
                </div>
                <div className='popular-locations'>
                  <TwistedAccordion
                    title="Popular Brands"
                    items={popularBrands}
                  />
                </div>
                <a href="/list-your-motorcycle/calculator">Calculate Earnings</a>
                <a href="/how-it-works">How It Works</a>
                <a href="/how-it-works/insurance">Insurance</a>
                <a href="/reviews">Customer Reviews</a>
                {isAuth &&
                  <a
                    href="https://support.twistedroad.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Help Center
                  </a>
                }
                <a href="/blog">Our Blog</a>
                <a href="/events">Events</a>
                <a
                  href="https://merch.twistedroad.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Merch
                </a>
                <a
                  href="https://mailchi.mp/twistedroad/holiday-gift-card-2025"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Gift Cards
                </a>
                <a href="/contact-us">Contact Us</a>
                {!isAuth &&
                  <a
                    href="https://support.twistedroad.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Help Center
                  </a>
                }
                {!isAuth && (
                  <div className="mobile-menu-logged-out-wrap">
                    <a
                      href="/list-your-motorcycle"
                      className="button is-primary is-fullwidth is-medium"
                    >
                      List A Bike
                    </a>
                  </div>
                )}
              </nav>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default MobileMenu
